export default function Icon() {
  return (
    <svg
      width="109"
      height="81"
      viewBox="0 0 109 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.849731 69.175H108.019"
        stroke="#E0E6F1"
        strokeWidth="0.146898"
      />
      <path
        d="M0.849731 57.7029H108.019"
        stroke="#E0E6F1"
        strokeWidth="0.146898"
      />
      <path
        d="M0.849731 46.1331H108.019"
        stroke="#E0E6F1"
        strokeWidth="0.146898"
      />
      <path
        d="M0.849731 34.6611H108.019"
        stroke="#E0E6F1"
        strokeWidth="0.146898"
      />
      <path
        d="M0.849731 23.189H108.019"
        stroke="#E0E6F1"
        strokeWidth="0.146898"
      />
      <path
        d="M0.849731 11.6191H108.019"
        stroke="#E0E6F1"
        strokeWidth="0.146898"
      />
      <mask
        id="mask0_1306_4418"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="109"
        height="81"
      >
        <path d="M0.751953 0H108.118V80.794H0.751953V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1306_4418)">
        <path
          d="M1.66174 72.4085L3.28553 71.7867L4.90931 71.5841L6.53309 71.6267L8.15687 70.9439L9.78066 70.5616L11.4044 70.367L13.0282 69.9859L14.652 70.0158L16.2758 69.4689L17.8996 68.5375L19.5234 67.7015L21.1471 67.3861L22.7709 67.0429L24.3947 66.4316L26.0185 65.7211L27.6423 65.4183L29.2661 65.1788L30.8898 64.8921L32.5136 63.3585L34.1374 61.9918L35.7612 61.6245L37.385 60.2911L39.0088 59.0453L40.6326 58.5053L42.2563 58.3487L43.8801 58.5111L45.5039 58.5191L47.1277 58.1196L48.7515 56.6113L50.3752 55.4058L51.999 55.0442L53.6228 54.3603L55.2466 53.8099L56.8704 53.1479L58.4942 52.3373L60.1179 51.7581L61.7417 50.6608L63.3655 49.2838L64.9893 47.6108L66.6131 47.7674L68.2369 49.8836L69.8606 51.0754L71.4844 51.4346L73.1082 50.4133L74.732 49.2596L76.3558 48.2153L77.9796 46.2878L79.6033 44.5158L81.2271 42.996L82.8509 40.9534L84.4747 40.0208L86.0985 39.437L87.7223 38.7151L89.346 37.1929L90.9698 36.1371L92.5936 34.5079L94.2174 32.3191L95.8412 32.197L97.465 36.4192L99.0887 35.3023L100.713 34.3513L102.336 35.2286L103.96 36.0358L105.584 36.2879L107.208 35.8803"
          stroke="#E492BD"
          strokeWidth="1.46898"
          strokeLinejoin="bevel"
        />
      </g>
      <mask
        id="mask1_1306_4418"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="109"
        height="81"
      >
        <path d="M0.751953 0H108.118V80.794H0.751953V0Z" fill="white" />
      </mask>
      <g mask="url(#mask1_1306_4418)">
        <path
          d="M1.66174 71.5838L3.28553 71.1382L4.90931 70.9713L6.53309 70.7686L8.15687 70.3265L9.78066 69.8118L11.4044 69.2891L13.0282 68.6731L14.652 68.3979L16.2758 68.1331L17.8996 67.2914L19.5234 66.6858L21.1471 65.9961L22.7709 65.4572L24.3947 64.6121L26.0185 63.9846L27.6423 63.2431L29.2661 62.5511L30.8898 61.904L32.5136 60.7319L34.1374 59.7578L35.7612 58.9449L37.385 58.1631L39.0088 57.1085L40.6326 56.5201L42.2563 56.6882L43.8801 55.7556L45.5039 55.0543L47.1277 54.2967L48.7515 53.4689L50.3752 53.1062L51.999 52.8483L53.6228 52.1954L55.2466 51.6946L56.8704 51.3388L58.4942 50.8552L60.1179 50.2381L61.7417 49.6508L63.3655 48.3405L64.9893 47.3722L66.6131 46.7574L68.2369 46.4914L69.8606 46.116L71.4844 46.4776L73.1082 45.8052L74.732 45.2064L76.3558 44.8403L77.9796 44.1322L79.6033 42.9716L81.2271 41.8858L82.8509 40.6573L84.4747 40.1702L86.0985 40.0136L87.7223 39.9699L89.346 39.142L90.9698 38.7908L92.5936 38.0931L94.2174 37.3562L95.8412 37.5128L97.465 38.9981L99.0887 38.3879L100.713 37.7166L102.336 37.8329L103.96 37.7385L105.584 37.8432L107.208 37.4046"
          stroke="#6061E5"
          strokeWidth="1.46898"
          strokeLinejoin="bevel"
        />
      </g>
      <mask
        id="mask2_1306_4418"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="109"
        height="81"
      >
        <path d="M0.751953 0H108.118V80.794H0.751953V0Z" fill="white" />
      </mask>
      <g mask="url(#mask2_1306_4418)">
        <path
          d="M1.66174 72.3471L3.28553 71.6183L4.90931 70.8388L6.53309 70.0432L8.15687 69.2672L9.78066 68.0329L11.4044 67.1659L13.0282 66.4359L14.652 65.8613L16.2758 64.8539L17.8996 63.646L19.5234 63.06L21.1471 62.4209L22.7709 62.0191L24.3947 61.007L26.0185 60.1573L27.6423 59.6691L29.2661 59.6127L30.8898 58.5269L32.5136 57.1971L34.1374 56.2656L35.7612 55.7164L37.385 54.7929L39.0088 53.683L40.6326 53.4516L42.2563 53.4884L43.8801 52.0215L45.5039 51.1303L47.1277 50.2484L48.7515 49.0152L50.3752 48.7274L51.999 48.6341L53.6228 48.8655L55.2466 48.1954L56.8704 47.15L58.4942 46.3256L60.1179 45.5622L61.7417 45.0187L63.3655 43.9594L64.9893 43.0383L66.6131 44.4545L68.2369 42.8794L69.8606 42.4453L71.4844 43.0579L73.1082 42.268L74.732 41.7292L76.3558 41.5392L77.9796 40.8829L79.6033 40.1045L81.2271 39.325L82.8509 38.1483L84.4747 37.4989L86.0985 37.5669L87.7223 37.9019L89.346 37.3872L90.9698 37.0568L92.5936 35.3861L94.2174 33.8421L95.8412 33.2595L97.465 35.8202L99.0887 33.9123L100.713 32.2451L102.336 31.233L103.96 31.3159L105.584 30.6746L107.208 29.9734"
          stroke="#231D2C"
          strokeWidth="1.46898"
          strokeLinejoin="bevel"
        />
      </g>
      <mask
        id="mask3_1306_4418"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="109"
        height="81"
      >
        <path d="M0.751953 0H108.118V80.794H0.751953V0Z" fill="white" />
      </mask>
      <g mask="url(#mask3_1306_4418)">
        <path
          d="M1.66174 70.7133L3.28553 71.0818L4.90931 71.3466L6.53309 70.1388L8.15687 69.3881L9.78066 68.551L11.4044 68.5199L13.0282 68.8423L14.652 68.1503L16.2758 68.186L17.8996 68.0386L19.5234 68.2597L21.1471 67.4675L22.7709 66.3645L24.3947 65.2096L26.0185 64.3772L27.6423 63.2338L29.2661 63.7312L30.8898 64.8619L32.5136 64.5959L34.1374 63.4975L35.7612 61.4826L37.385 60.6466L39.0088 59.5563L40.6326 58.6778L42.2563 58.7929L43.8801 57.6933L45.5039 55.8453L47.1277 54.6064L48.7515 53.6116L50.3752 52.3946L51.999 51.5518L53.6228 51.3871L55.2466 52.3785L56.8704 51.5011L58.4942 50.763L60.1179 49.1718L61.7417 46.9197L63.3655 47.5587L64.9893 47.7326L66.6131 47.69L68.2369 48.1436L69.8606 49.6347L71.4844 49.5449L73.1082 48.6997L74.732 48.8356L76.3558 47.4908L77.9796 46.1436L79.6033 44.3106L81.2271 43.2513L82.8509 42.0101L84.4747 41.0844L86.0985 41.2583L87.7223 40.4684L89.346 37.5392L90.9698 35.6671L92.5936 34.8496L94.2174 31.6487L95.8412 31.9987L97.465 34.6642L99.0887 36.0113L100.713 35.0787L102.336 34.7264L103.96 33.537L105.584 33.2157L107.208 32.1277"
          stroke="#E75656"
          strokeWidth="1.46898"
          strokeLinejoin="bevel"
        />
      </g>
      <mask
        id="mask4_1306_4418"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="109"
        height="81"
      >
        <path d="M0.751953 0H108.118V80.794H0.751953V0Z" fill="white" />
      </mask>
      <g mask="url(#mask4_1306_4418)">
        <path
          d="M1.66174 67.5101L3.28553 66.8953L4.90931 66.5153L6.53309 66.0651L8.15687 65.4434L9.78066 65.2235L11.4044 64.5142L13.0282 64.14L14.652 64.2482L16.2758 63.6587L17.8996 62.8009L19.5234 61.7842L21.1471 61.3605L22.7709 60.7226L24.3947 59.8349L26.0185 58.8424L27.6423 58.1424L29.2661 56.8781L30.8898 56.4913L32.5136 55.5437L34.1374 55.151L35.7612 53.9386L37.385 52.7078L39.0088 51.5909L40.6326 50.4694L42.2563 48.9715L43.8801 47.1707L45.5039 45.7867L47.1277 44.6019L48.7515 43.0026L50.3752 41.15L51.999 40.7896L53.6228 40.7378L55.2466 39.3239L56.8704 36.8772L58.4942 34.6043L60.1179 32.9705L61.7417 32.0782L63.3655 32.2209L64.9893 31.8202L66.6131 30.845L68.2369 29.552L69.8606 28.0287L71.4844 26.8508L73.1082 24.4501L74.732 22.4168L76.3558 19.7962L77.9796 16.9246L79.6033 15.6396L81.2271 14.783L82.8509 13.11L84.4747 12.0496L86.0985 11.437L87.7223 11.2079L89.346 8.88323L90.9698 7.4981L92.5936 6.3467L94.2174 4.95581L95.8412 5.60635L97.465 7.75025L99.0887 8.22003L100.713 8.46067L102.336 7.44398L103.96 7.7871L105.584 6.98343L107.208 6.65643"
          stroke="#70777E"
          strokeWidth="1.46898"
          strokeLinejoin="bevel"
        />
      </g>
      <mask
        id="mask5_1306_4418"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="109"
        height="81"
      >
        <path d="M0.751953 0H108.118V80.794H0.751953V0Z" fill="white" />
      </mask>
      <g mask="url(#mask5_1306_4418)">
        <path
          d="M1.66174 75.3187L3.28553 75.1679L4.90931 75.1322L6.53309 74.9076L8.15687 74.6808L9.78066 74.4943L11.4044 74.3285L13.0282 74.0982L14.652 73.876L16.2758 73.777L17.8996 73.5018L19.5234 73.017L21.1471 73.199L22.7709 72.8248L24.3947 72.5461L26.0185 72.165L27.6423 71.6941L29.2661 71.4339L30.8898 70.9399L32.5136 71.1034L34.1374 70.6728L35.7612 70.0384L37.385 69.3498L39.0088 68.6014L40.6326 68.0073L42.2563 67.5352L43.8801 67.3337L45.5039 67.2094L47.1277 66.8409L48.7515 67.2209L50.3752 67.6769L51.999 68.4794L53.6228 68.6981L55.2466 68.2203L56.8704 67.8715L58.4942 67.8473L60.1179 67.5364L61.7417 67.792L63.3655 67.549L64.9893 67.7862L66.6131 69.0804L68.2369 69.9336L69.8606 69.6964L71.4844 69.3153L73.1082 68.7373L74.732 67.9233L76.3558 67.1369L77.9796 66.1858L79.6033 65.4685L81.2271 64.7788L82.8509 63.9256L84.4747 63.7195L86.0985 63.4662L87.7223 62.8398L89.346 61.9118L90.9698 61.2371L92.5936 60.0177L94.2174 58.5267L95.8412 57.6724L97.465 57.084L99.0887 56.1387L100.713 54.9815L102.336 54.5129L103.96 54.0478L105.584 53.1174L107.208 52.156"
          stroke="#73D3CD"
          strokeWidth="1.46898"
          strokeLinejoin="bevel"
        />
      </g>
      <mask
        id="mask6_1306_4418"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="109"
        height="81"
      >
        <path
          d="M1.48644 0.734491H107.383V80.0595H1.48644V0.734491Z"
          fill="white"
          stroke="white"
          strokeWidth="1.46898"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask6_1306_4418)">
        <path
          d="M1.66174 72.0444L3.28553 72.148L4.90931 71.7439L6.53309 71.5067L8.15687 71.2154L9.78066 70.5786L11.4044 69.798L13.0282 69.7623L14.652 69.1394L16.2758 69.4641L17.8996 68.6109L19.5234 68.1365L21.1471 67.9995L22.7709 68.4681L24.3947 67.068L26.0185 66.4612L27.6423 65.9316L29.2661 65.433L30.8898 64.6892L32.5136 64.6086L34.1374 63.5229L35.7612 63.2293L37.385 63.2949L39.0088 62.0019L40.6326 61.5897L42.2563 61.6634L43.8801 60.9011L45.5039 60.5615L47.1277 60.1804L48.7515 60.3945L50.3752 60.4809L51.999 60.4095L53.6228 60.0272L55.2466 59.4907L56.8704 59.364L58.4942 59.3076L60.1179 58.5649L61.7417 58.4107L63.3655 58.0595L64.9893 57.7762L66.6131 58.4176L68.2369 59.5885L69.8606 62.6639L71.4844 64.208L73.1082 66.2632L74.732 66.8642L76.3558 67.3432L77.9796 67.1337L79.6033 67.8314L81.2271 66.9655L82.8509 65.5286L84.4747 64.6892L86.0985 63.8522L87.7223 62.5407L89.346 61.1602L90.9698 59.8349L92.5936 58.0595L94.2174 56.086L95.8412 54.7826L97.465 56.8171L99.0887 55.7521L100.713 54.7089L102.336 53.8695L103.96 53.5679L105.584 53.8764L107.208 54.1701"
          stroke="#ADB5BD"
          strokeWidth="1.46898"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M1.66174 67.8752L3.28553 67.5517L4.90931 67.6081L6.53309 67.166L8.15687 66.6801L9.78066 66.2679L11.4044 66.2207L13.0282 66.071L14.652 66.1055L16.2758 65.5874L17.8996 64.9253L19.5234 64.7066L21.1471 64.6951L22.7709 64.124L24.3947 63.3479L26.0185 63.0889L27.6423 62.8563L29.2661 62.5304L30.8898 61.8626L32.5136 61.5644L34.1374 61.1994L35.7612 60.8839L37.385 60.2092L39.0088 58.77L40.6326 59.0486L42.2563 59.166L43.8801 58.5811L45.5039 58.0319L47.1277 57.28L48.7515 56.6652L50.3752 57.1879L51.999 57.4965L53.6228 56.9692L55.2466 56.1056L56.8704 55.4758L58.4942 54.6192L60.1179 53.6198L61.7417 52.4281L63.3655 51.0475L64.9893 50.4384L66.6131 50.2715L68.2369 50.7401L69.8606 50.6883L71.4844 49.9675L73.1082 48.8127L74.732 48.0919L76.3558 47.3078L77.9796 46.5433L79.6033 45.4471L81.2271 44.4569L82.8509 43.2261L84.4747 42.3752L86.0985 41.6015L87.7223 40.1092L89.346 39.3493L90.9698 38.48L92.5936 37.514L94.2174 36.7541L95.8412 37.2434L97.465 39.4299L99.0887 38.9694L100.713 38.6136L102.336 38.6297L103.96 38.2002L105.584 37.3873L107.208 36.6838"
        stroke="#9A60B4"
        strokeWidth="0.734491"
        strokeLinejoin="bevel"
      />
    </svg>
  );
}
